import { render, staticRenderFns } from "./StoreLocatorFaq.vue?vue&type=template&id=5328bc7a&scoped=true&"
import script from "./StoreLocatorFaq.vue?vue&type=script&lang=js&"
export * from "./StoreLocatorFaq.vue?vue&type=script&lang=js&"
import style0 from "./StoreLocatorFaq.vue?vue&type=style&index=0&id=5328bc7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328bc7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
